module.exports = __webpack_public_path__ + "img/apples.36a699e2.jpg";